import useModalStore from '@features/modal/model'
import { useAddressStore } from '@features/shipping-methods'

import { ModalDelivery } from '@widgets/modal-delivery'
import { useSlots, useSlotStore } from '@widgets/slots'



import styles from './styles.module.scss'

export default function useDeliveryModal () {
  const { openModal, closeModal } = useModalStore()
  const { openSlotsModal } = useSlots()
  const { selectedSlot } = useSlotStore()
  const { selectedAddress } = useAddressStore()
  const openDeliveryModal = (onCloseCallback?: () => void) =>
    openModal('delivery', <ModalDelivery />, {
      classes: {
        modal: styles['modal'],
        body: styles['modal__body'],
        content: styles['modal__content'],
      },
      onClose: () => {
        if (selectedAddress && !selectedSlot) {
          openSlotsModal()
        }
        if (onCloseCallback) {
          onCloseCallback()
        }
      },
    })

  const closeDeliveryModal = () => closeModal('delivery')

  return {
    openDeliveryModal,
    closeDeliveryModal,
  }
}
